import React, { useEffect, useState, useRef } from "react";
import BreadcrumbsComponent from "../../../../components/BreadcrumbsComponent";
import { Box, Typography, Button, ClickAwayListener, Popover, Alert, TextField, Menu, MenuItem } from "@mui/material";
import { experimentalStyled as styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import FlagRoundedIcon from "@mui/icons-material/FlagRounded";
import DirectionsRunRoundedIcon from "@mui/icons-material/DirectionsRunRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import ViewWeekRoundedIcon from "@mui/icons-material/ViewWeekRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import EditIcon from '@mui/icons-material/Edit';
import TaskWorkFlowModalPage from "../../../../components/Modal/TaskWorkFlow";
import "../projectpages.scss";
import "./activesprintpage.scss";
import IconButton from "@mui/material/IconButton";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import ScrumCycleImage from '../../../../assets/images/clipart-agile-software-development-jira-scrum--removebg-preview.png'
import { NavLink, useNavigate, useLocation, useSearchParams } from 'react-router-dom'
import BacklogHeader from '../../../../components/BaclogHeader'
import AddPeopleToProject from '../AddPeopleToProject'
import { useSelector, useDispatch } from "react-redux";
import { FiPlus } from "react-icons/fi";
import moment from 'moment';
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { Textarea } from '@mui/joy';
import { createIssue, getActiveProjectData, getLastFiveActiveSprintInfo, getSprintsList, SetlastfiveActiveSprintInfo, setSelectedProjectBackLogId, setSkeletonStatus, updateIssue } from '../../../../common/Redux/Reducer';
import IssueTypeMenuList from '../../../../common/IssueTypeMenuList';

import { updateSprint } from '../../../../common/Redux/Reducer';
import { Tooltip } from "@mui/material";
import { issueStatus, taskPriorityList, taskTypesList } from "../../../../utilities/Json";
import { getIssueTypeIcon, getPriorityIcon, getTaskIcon } from "../../../../utilities/Icons";
import CompletConfirmationModal from '../../../../components/Modal/DeleteConfirmationModal';
import ActiveSprintAssigneesLayout from "../../../../components/ActiveSprintAssigneesLayout";
import SearchableDropdown from '../../../../components/Modal/SearchableDropDown';
import { usePageSearch } from '../../../../context/PageSearchContext';
import BackgroundLetterAvatarsLogo from '../../../../components/AvatarLogo';
import { IssueStatusCardSkeleton, NormalSkeleton } from "../../../../common/Skeleton";
import SprintStartModal from "../../../../components/ProjectIssues/SprintStartModal";
import DeleteTaskStatus from "../../../../components/DeleteTaskStatus";
import axios from "axios";
import API_BASE_URL from "../../../../components/config/appConfig";
import { useToast } from "../../../../components/Toast";
import { useParams } from 'react-router-dom';
import BoltIcon from '@mui/icons-material/Bolt';
import SnackbarComponent from "../../../../common/snackbars";
import useDropHighlight from "../../../../common/useDropHighlight";
import ViewKanbanRoundedIcon from "@mui/icons-material/ViewKanbanRounded";
import DeliveryTracker from "../../../../components/DeliveryTracker";
import KanbanBoard from "../../../../components/KanbanBoard";
import WipLimitControl, { isOverWip } from "../../../../components/DeliveryTracker/WipLimitControl";
// import { object } from "prop-types";


// Enhanced Loading Component
const EnhancedLoader = ({ size = 'medium', text = 'Loading...', variant = 'spinner' }) => {
  const sizeMap = {
    small: { width: '16px', height: '16px', fontSize: '11px' },
    medium: { width: '24px', height: '24px', fontSize: '13px' },
    large: { width: '32px', height: '32px', fontSize: '14px' }
  };

  const currentSize = sizeMap[size];

  if (variant === 'dots') {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1.5
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '4px',
            alignItems: 'center'
          }}
        >
          {[0, 1, 2].map((index) => (
            <Box
              key={index}
              sx={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: '#1976d2',
                animation: 'dotPulse 1.4s ease-in-out infinite both',
                animationDelay: `${index * 0.16}s`,
                '@keyframes dotPulse': {
                  '0%, 80%, 100%': {
                    transform: 'scale(0.8)',
                    opacity: 0.5
                  },
                  '40%': {
                    transform: 'scale(1)',
                    opacity: 1
                  }
                }
              }}
            />
          ))}
        </Box>
        <Typography 
          sx={{ 
            fontSize: currentSize.fontSize, 
            color: '#555',
            fontWeight: '500',
            textAlign: 'center'
          }}
        >
          {text}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5
      }}
    >
      <Box
        sx={{
          width: currentSize.width,
          height: currentSize.height,
          borderRadius: '50%',
          background: 'conic-gradient(from 0deg, #1976d2, #42a5f5, #1976d2)',
          animation: 'spin 1s linear infinite',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: '2px',
            left: '2px',
            right: '2px',
            bottom: '2px',
            backgroundColor: 'white',
            borderRadius: '50%'
          },
          '@keyframes spin': {
            '0%': { transform: 'rotate(0deg)' },
            '100%': { transform: 'rotate(360deg)' }
          }
        }}
      />
      <Typography 
        sx={{ 
          fontSize: currentSize.fontSize, 
          color: '#555',
          fontWeight: '500',
          textAlign: 'center'
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

const EachTask = styled(Paper)(({ theme }) => ({
  backgroundColor: '#F7F8FB',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'start',
  color: theme.palette.text.secondary,
  // minHeight: '180px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  border: '1px solid #EFF1F6',
  borderRadius: '14px',
  //width:'100%'
  //   minWidth: '195px',
  //  maxWidth:'195px'
  // maxWidth: '280px'
}));

const buttonStyles = {
  backgroundColor: "#60A630",
  color: "#fff",
  borderRadius: "8px",
  textTransform: "none",
  '&:hover': {
    backgroundColor: "#4b8e27",
  }
};

const btnGroupBtnStyles = { backgroundColor: "transparent !important", border: '0px !important', color: "#000000 !important" }

/* A shimmering block. Sized by the caller so the placeholder matches the shape
   of whatever will land in its place. */
const Bar = ({ w, h = 12, r = 6 }) => (
  <span className="sb-shimmer" style={{ width: w, height: h, borderRadius: r }} />
);

/**
 * What the board shows from mount until this project's sprint list has come
 * back. Without it the page cannot tell "still fetching" from "there is no
 * sprint", so the empty state flashes for a moment on every refresh.
 *
 * The hero keeps its real card and runs a slim indeterminate bar along the top
 * edge; the lanes below are drawn in the board's own geometry, so nothing
 * jumps when the real data replaces them.
 */
const SprintBootLoader = ({ lanes = 5 }) => (
  <>
    <section className="sprint-hero is-loading" aria-busy="true" aria-label="Loading sprint board">
      <span className="sprint-hero__progress" aria-hidden="true" />

      <div className="sprint-boot__row">
        <Bar w={210} h={13} />
        <div className="sprint-boot__row-end">
          <Bar w={128} h={28} r={999} />
          <Bar w={146} h={30} r={10} />
        </div>
      </div>

      <div className="sprint-boot__identity">
        <Bar w={44} h={44} r={14} />
        <div className="sprint-boot__heading">
          <Bar w={228} h={19} />
          <div className="sprint-boot__chips">
            <Bar w={152} h={24} r={999} />
            <Bar w={186} h={24} r={999} />
          </div>
        </div>
      </div>

      <div className="sprint-boot__row sprint-boot__row--toolbar">
        <Bar w={268} h={34} r={10} />
        <Bar w={176} h={34} r={999} />
      </div>
    </section>

    <div className="sprint-boot__board" aria-hidden="true">
      {Array.from({ length: lanes }).map((_, lane) => (
        <div
          className="sprint-boot__lane"
          key={lane}
          style={{ "--sb-boot-delay": `${lane * 70}ms` }}
        >
          <div className="sprint-boot__lane-head">
            <Bar w={82} h={11} r={4} />
            <Bar w={24} h={18} r={999} />
          </div>
          {Array.from({ length: lane % 2 ? 2 : 3 }).map((_, card) => (
            <div className="sprint-boot__card" key={card}>
              <Bar w={54} h={10} r={4} />
              <Bar w={card % 2 ? "72%" : "92%"} h={13} />
              <div className="sprint-boot__card-foot">
                <Bar w={22} h={18} r={6} />
                <Bar w={16} h={16} r={4} />
                <Bar w={22} h={22} r={999} />
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  </>
);

const ActiveSprintPage = ({ sprintData = {} }) => {
  const [searchParams, setSearchparams] = useSearchParams();
  let urlQueryObj = Object.fromEntries([...searchParams]);
  const [modalOpen, setModalOpen] = useState(urlQueryObj?.selectedIssue ? urlQueryObj?.selectedIssue : false);
  const [workFlowModalData, setWorkFlowModalData] = useState({});
  const [openAddPeopleModel, setOpenAddPeopleModel] = useState(false);
  const [groupBy, setGroupBy] = useState("none");
  const [issueType, setIssueType] = useState(taskTypesList[0]);
  const [priority, setPriority] = useState(taskPriorityList[0]);
  const [isEditing, setIsEditing] = useState(false);
  const [currentTaskIndex, setCurrentTaskIndex] = useState(null);
  const [createIssueTitle, setCreateIssueTitle] = useState("");
  /* shared with the top bar, so either box filters this board */
  const [searchTerm, setSearchTerm] = usePageSearch("Search issues in this sprint…");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedTaskType, setSelectedTaskType] = useState("");
  const [selectPriorityType, setSelectPriorityType] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [sprintId, setSprinId] = useState(null);
  const [isSprintEditable, setIsSprintEditable] = useState(false);
  //const [backlogId , setBacklogId] = useState();
  const [showInput, setShowInput] = useState(false);
  const [inputValue, setInputValue] = useState("");
  // const [hoveredIndex, setHoveredIndex] = useState(null);
  const [projectDetails, setProjectDetails] = useState();
  //const [issueStatusList, setIssueStatusList] = useState([]);
  const [ShowCopied, setShowCopied] = useState(false);
  const [openTaskStatusDialog, setOpenTaskStatusDialog] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState();
  const [remaingWorkingDays, setRemainingWorkDays] = useState(0)
  const inputRef = useRef(null);
  const [selectedIssueName, setSelectedIssueName] = useState(urlQueryObj?.selectedIssue || null);
  const { projectSlug } = useParams();
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [assigneeUpdating, setAssigneeUpdating] = useState(null);

  const draggedTodoItem = React.useRef(null);
  /* which column the pointer is over right now, so the board can show it */
  const { activeZone, getZoneProps, clearZone } = useDropHighlight();

  const navigate = useNavigate()
  // const location = useLocation()
  const dispatch = useDispatch()
  const toast = useToast();

  const filterAssigneesArray = useSelector((state) => state.ProjamAppSlice.assignee)
  const { Projects, Skeleton, assignees, sprintsListLoaded } = useSelector((state) => state.ProjamAppSlice)
  const activeSprint = Projects?.selectedProject?.ActiveSprint;
  const contributors = Projects?.selectedProject?.contributors;
  const projectIssuesData = Projects?.selectedProject?.sprintsList;
  let ProjectName = Projects?.selectedProject?.selectedProjectData?.title
  let backlogId = Projects?.selectedProject?.selectedProjectBackLogId
  let projectId = Projects?.selectedProject?.selectedProjectData?._id
  const ActiveSprintEpicsData = Projects?.selectedProject?.ActiveSprintEpicsData
  const userDetails = Projects?.selectedProject?.loggedUserDetails

  const [issueStatusList, setIssueStatusList] = useState([]);
 
  const [issueCountObj , setIssueCountObj]=useState(activeSprint?.IssuecountObj||{})

  const startDate = moment(new Date());
  const endDate = moment(activeSprint?.endDate);

  const duration = endDate.diff(startDate, "days");


  const [editingTaskIndex, setEditingTaskIndex] = useState(null);
  const [newTaskTitle, setNewTaskTitle] = useState('');
  const [selectedEpic, setSelectedEpic] = useState('')
  const [activeSprintEpicsData, setActiveSprintEpicsData] = useState([])
  const [sprintDates, setSprintDates] = useState([])

  useEffect(() => {
    console.log(activeSprint, "activeSprint")
    if (activeSprint?.IssuecountObj) {
    
      setIssueCountObj(activeSprint?.IssuecountObj)
    }
  }, [activeSprint?.IssuecountObj])

  useEffect(() => {
    if (ActiveSprintEpicsData) {
      const updatedProjectEpicData = ActiveSprintEpicsData?.map((eachData) => ({ ...eachData, icon: <span className="epic-icon-cls"><BoltIcon sx={{ color: '#fff', height: "0.7rem", fontSize: '1.4rem' }} /></span> }))
      setActiveSprintEpicsData(updatedProjectEpicData || [])
    }
  }, [ActiveSprintEpicsData])

  const getHowmanyWorkingDays = () => {
    try {
      let DatesArray = Array.from({ length: duration }).map((_, i) => {
        let nextDate = new Date();
        nextDate.setDate(nextDate.getDate() + i);
        return nextDate;
      });

      setSprintDates(DatesArray);

      let WeekoffDayArray = DatesArray.filter((eachDate) => {
        return moment(eachDate).format("ddd") === "Sat" || moment(eachDate).format("ddd") === "Sun";
      });

      const workingDaysLeft = duration - WeekoffDayArray.length;
      setRemainingWorkDays(workingDaysLeft);
      console.log(DatesArray, "sprintDates");
    } catch (error) {
      console.log(error);
    }
  };

  const handleCopyUrl = async () => {
    try {
      navigator.clipboard.writeText(window.location.href)
      setSnackbarMessage('URL Copied Successfully');
      setSnackbarOpen(true);
      setShowCopied(true)
    }
    catch (error) {
      console.log('failed to copy ')
    }
  }
  const handleEditClick = (index, title) => {
    setIsEditing(true)
    setEditingTaskIndex(index);
    setNewTaskTitle(title);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarMessage("");
  }

  const handleSaveIssue = async (index, id) => {
    try {
      //const projectId = localStorage.getItem("projectId")
      const trimedTitle = newTaskTitle.trim();
      const response = await axios.put(`${API_BASE_URL}/projects/UpdateIssueStatus/${id}`, {
        projectId: projectId,
        status: trimedTitle,
      });
      setIssueStatusList(response.data.IssueStatus)
      // setIssueStatusList(updatedIssueStatusList);
    } catch (error) {
      console.error('Error saving issue:', error);
    }
    finally {
      getProjectDetails()
      //  await dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: filterAssigneesArray }));
      setNewTaskTitle('');
      setIsEditing(false);
      setEditingTaskIndex(null)
    }
  };
  const handleCancelIssue = () => {
    setIsEditing(false)
    setEditingTaskIndex(null);
    setNewTaskTitle('');
  };

  const getUpdatedBurnDownInfo = async () => {
    try {
      let response = await dispatch(getLastFiveActiveSprintInfo({ backlogId, projectId }));
      dispatch(SetlastfiveActiveSprintInfo(response?.payload))

    }
    catch (error) {
      console.log(error)
    }
  }

  const handleColumnDrop = async (status = '', draggedItemType) => {
    try {
      const dragged = draggedTodoItem?.current;

      /* nothing is being dragged, or the card was dragged from a different kind
         of source than this lane accepts */
      if (!dragged || draggedItemType !== dragged?.draggedItemType) {
        draggedTodoItem.current = null;
        return;
      }

      let issueObj = filteredData.find((issue) => issue._id == dragged?.id)
      const sts = issueObj?.status

      /* dropped back into the lane it came from — the board is unchanged, so
         leave the counts and the card order exactly as they are */
      if (!issueObj || sts?.toLowerCase() === status?.toLowerCase()) {
        draggedTodoItem.current = null;
        return;
      }

      /* only a real lane-to-lane move touches the counts: one off the source
         lane, one onto the target lane */
      const countOf = (title) => Number(issueCountObj?.[title]) || 0;
      const dummyIssueCountObj = {
        ...issueCountObj,
        [status]: countOf(status) + 1,
        [sts]: Math.max(0, countOf(sts) - 1),
      };

      let customArray = [...filteredData]

      issueObj = { ...issueObj, status: status, updatedAt: new Date() }
      const indexOfTheIssue = customArray.findIndex(obj => obj._id == dragged?.id)

      if (indexOfTheIssue !== -1) {
        customArray.splice(indexOfTheIssue, 1, issueObj)
        customArray = customArray.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
        setFilteredData(customArray)
        setIssueCountObj(dummyIssueCountObj)
      }

      draggedTodoItem.current = null
      await dispatch(updateIssue({ issueId: dragged?.id, payload: { status: status } }));
      await dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: filterAssigneesArray }));
      getUpdatedBurnDownInfo()
    }
    catch (error) {
      console.log(error)
      draggedTodoItem.current = null
    }
  };

  /* Green when the hovered column would actually move the card, neutral when it
     is the column the card already sits in. Only lights up for issue drags. */
  const dropStateClass = (statusTitle) => {
    const dragged = draggedTodoItem?.current;
    if (!dragged || dragged.draggedItemType !== 'issue') return '';
    if (activeZone !== `status-${statusTitle}`) return '';
    return dragged?.status?.toLowerCase() === statusTitle?.toLowerCase()
      ? 'is-drop-origin'
      : 'is-drop-target';
  };

  const onChangeModalStatus = (data) => {
    setWorkFlowModalData(data);
    setSearchparams({ selectedIssue: data?.name })
    setModalOpen(true);
  };
  const handileNavigation = () => {
    navigate(`/projects/${projectSlug}/backlog`);
  };

  const handleCreateIssueClick = (index) => {
    setIsEditing(true);
    setCurrentTaskIndex(index);
  };

  const handleSearch = (text) => {
    setSearchTerm(text);
  };

  const handleStatuUpdate = (value) => {
    setSelectedTaskType(value);
  };

  const handlePriorityUpdate = (priority) => {
    setSelectPriorityType(priority)
  }

  useEffect(() => {
    if (searchTerm) {
      const lowercasedTerm = searchTerm.toLowerCase();
      const filteredIssues = activeSprint?.issues?.filter((issue) =>
        issue?.summary?.toLowerCase().includes(lowercasedTerm) ||
        issue?.name?.toLowerCase().includes(lowercasedTerm)
      );
      setFilteredData(filteredIssues);
    } else {
      setFilteredData(activeSprint?.issues || []);
    }
  }, [searchTerm, activeSprint]);

  useEffect(() => {
    let filteredData = activeSprint?.issues || [];
    if (selectedEpic) {
      filteredData = filteredData?.filter(
        (eachIssue) => (eachIssue?.name?.toLowerCase() === selectedEpic?.toLowerCase() || eachIssue?.title?.toLowerCase() === selectedEpic?.toLowerCase())
      );
    } else {
      if (selectedTaskType) {
        filteredData = filteredData?.filter(issue =>
          issue?.issueType?.toLowerCase() === selectedTaskType?.toLowerCase()
        );
      }

      if (selectPriorityType) {
        filteredData = filteredData?.filter(issue =>
          issue?.priority?.toLowerCase() === selectPriorityType?.toLowerCase()
        );
      }

      if(assignees.length){
      
        filteredData = filteredData?.filter((Issue)=>{
        //  console.log(assignees , "hhhhh")
          // return Issue?.assignee[0]?.employeeName?.includes(assignees)

            return assignees.some((name)=>{
             
              return Issue?.assignee[0]?.employeeName  == name  || Issue?.assignee[0]?.employeeEmail== name
            })

      })
      }
    
    }
    setFilteredData(filteredData);
  }, [selectedTaskType, selectPriorityType, activeSprint, selectedEpic , assignees]);

  useEffect(() => {
    if (Projects?.selectedProject?.selectedProjectData?.IssueStatus) {
      setIssueStatusList(Projects?.selectedProject?.selectedProjectData?.IssueStatus)
    }
  }, [Projects?.selectedProject?.selectedProjectData?.IssueStatus]);

  useEffect(() => {

  }, [issueStatusList, isEditing, showInput, editingTaskIndex])

  const handleTextareaSubmit = async (event, selectedStatus = "To Do", assignee = []) => {
    event.preventDefault();
    const Values = {
      project: projectId,
      issueType: issueType?.name,
      status: selectedStatus,
      summary: createIssueTitle,
      components: "",
      description: "",
      reporter: "",
      assignee: assignee,
      backlog: backlogId,
      sprint: activeSprint?._id,
      priority: priority?.name,
      storyPointEstimate:1
    }
    if (createIssueTitle) {
      // await dispatch(setSkeletonStatus({ Skeleton: true }))
      let valueWithId= {...Values , _id:'123456789'}
      let created = [...filteredData , valueWithId]
      setFilteredData(created)
      setIsEditing(false);
      setCurrentTaskIndex(null);
      setCreateIssueTitle('');
      await dispatch(createIssue(Values))
      await dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: filterAssigneesArray }));
     
      // await dispatch(setSkeletonStatus({ Skeleton: false }));

      getUpdatedBurnDownInfo() // updating the burndown info when new issue created
    }
  };
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const handleConfirm = async () => {
    await dispatch(updateSprint({ sprintId: activeSprint?._id, payload: { active: false, completed: true } }));
    await dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: filterAssigneesArray }));
    setOpenDeleteDialog(false)
  };

  const handleCompletSprint = () => {
    setOpenDeleteDialog(true)
  }

  const handleClickAway = () => {
    setIsEditing(false);
    setCurrentTaskIndex(null);
  };

  const handleChangeIssueTitle = (event) => {
    setCreateIssueTitle(event.target.value)
  }

  const [anchorEl, setAnchorEl] = useState({ id: "", element: null });

  const handlePopOverClick = (event, rowId) => {
    setAnchorEl({ id: rowId, element: event.currentTarget });
  };

  const handlePopOverClose = () => {
    setAnchorEl({ id: "", element: null });
  };

  const handleAssigneeUpdate = async (taskId, selectedUser) => {
    try {
      setAssigneeUpdating(taskId);
      await dispatch(updateIssue({ issueId: taskId, payload: { assignee: selectedUser ? [selectedUser] : [] } }));
      await dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: [] }));
      handlePopOverClose();
    } catch (error) {
      console.error('Error updating assignee:', error);
    } finally {
      setAssigneeUpdating(null);
    }
  };

  const handleStartSprint = async (values, sprintId) => {
    try {
      await axios.put(`${API_BASE_URL}/sprints/updateSprint/${sprintId}`, {
        active: true,
        completed: false,
      });
      await dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: filterAssigneesArray }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setShowInput(false);
    setInputValue("");
    // getProjectDetails();
  }, [projectSlug])

  useEffect(() => {
    getHowmanyWorkingDays()
  }, [duration])

  // const [projectDetails, setProjectDetails] = useState();

  const getProjectDetails = async () => {
    // const projectId = localStorage.getItem('projectId');
    //const token = localStorage.getItem("accessToken");
    try {
      // const response = await axios.get(`${API_BASE_URL}/projects/getProjectsByslug/${projectSlug}` , {
      //   headers:{
      //     Authorization:`Bearer ${token}`
      //   }
      // });

      //
      let projectInfo = await dispatch(getActiveProjectData(projectSlug))
      const { payload } = projectInfo
      if (!payload) {
        navigate('/projects')
      }
      // const issueStatuses = payload?.IssueStatus || [];
      dispatch(setSelectedProjectBackLogId({ id: payload?.backlogs[0] }));
      // setIssueStatusList(issueStatuses);
    } catch (error) {
      console.error('Error fetching project details:', error);
      // throw new Error(error.message);
      navigate('/projects')
    }
  };

  const handleCancelClick = () => {
    console.log("cancelclick")
    setShowInput(false);
    setInputValue(""); // Clear the input field
  };

  const handleSaveClick = async () => {
    if (inputValue) {
      try {

        //const projectId = localStorage.getItem("projectId");
        const response = await axios.post(`${API_BASE_URL}/projects/addIssueStatus`, {
          projectId: projectId,
          status: inputValue.trim(),
        });

        setIssueStatusList(response.data.IssueStatus);
        setShowInput(false);
        setInputValue("");
      } catch (error) {
        console.error("Error adding issue status:", error);
      }
      finally {
        getProjectDetails();
        setNewTaskTitle('');
        // setIsEditing(false);
        // setEditingTaskIndex(null)
        // await dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: filterAssigneesArray }));

      }
    }

  };

  const handleAddTaskItem = () => {
    setShowInput(true);
  }


  const handleDeleteTaskStatus = (id) => {
    setSelectedTaskId(id)
    setOpenTaskStatusDialog(true);

  };

  const handleCloseModal = () => {
    setOpenTaskStatusDialog(false);
    setSelectedTaskId(null)
  };

  const handleDeleteConfirm = async () => {
    //console.log(selectedTaskId, "selectedTaskId");
    try {
      // const projectId = localStorage.getItem("projectId");

      await axios.delete(`${API_BASE_URL}/projects/removeIssueStatus/${selectedTaskId}`, {
        data: { projectId: projectId },
      });
      toast.success("Issue status deleted");
    } catch (error) {
      console.log('Error', error);
      toast.error("Could not delete the issue status");
    } finally {
      getProjectDetails()
      handleCloseModal();
      // await dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: filterAssigneesArray }));
    }
  };

  const handleEpicData = (data) => {
    // console.log(data, "setSelectedEpic")
    if (data) {
      setSelectedEpic(data);
    } else {
      setSelectedEpic(data);
    }
  }

  const userAccess = (userDetails?.role === 'Project Manager' || userDetails?.role === 'Project Lead' || userDetails?.role === 'Scrum Master' || userDetails?.role === 'Project Owner') ? true : false

  /* header summary — issueCountObj is { [status]: count } and is updated
     optimistically while cards are dragged, so the bar follows the board */
  /* Until this project's sprint list has landed the store still holds the empty
     default (or the previous project's data), so rendering the board's decision
     now would flash the "no sprint" card. Wait for both: the slug in the store
     caught up with the URL, and the fetch for it finished. */
  const isBootingBoard = !sprintsListLoaded || Projects?.selectedProject?.projectSlug !== projectSlug

  const hasActiveSprint = Boolean(activeSprint && Object.keys(activeSprint)?.length > 0)
  // a Kanban board flows to a release date and limits work in progress per column
  const isKanban = activeSprint?.boardType === "kanban"
  const wipLimits = activeSprint?.wipLimits || {}

  /* Kanban adds cards to its queue column with the title typed on the card,
     so it can't go through the sprint composer's shared title state */
  const handleKanbanCreate = async (status, summary) => {
    try {
      await dispatch(createIssue({
        project: projectId,
        issueType: issueType?.name || "Task",
        status,
        summary,
        components: "",
        description: "",
        reporter: "",
        assignee: [],
        backlog: backlogId,
        sprint: activeSprint?._id,
        priority: priority?.name || "Medium",
        storyPointEstimate: 1,
      })).unwrap()
      await dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: filterAssigneesArray }))
      getUpdatedBurnDownInfo()
    } catch (error) {
      toast.error(error?.message || "Could not add the card")
    }
  }

  const handleWipSave = async (statusId, limit) => {
    try {
      const next = { ...wipLimits, [statusId]: limit }
      if (!limit) delete next[statusId]
      await axios.put(`${API_BASE_URL}/sprints/updateSprint/${activeSprint?._id}`, { wipLimits: next })
      await dispatch(getLastFiveActiveSprintInfo({ backlogId, projectId }))
      toast.success(limit ? `WIP limit set to ${limit}` : "WIP limit removed")
    } catch (error) {
      toast.error(error?.response?.data?.message || "Could not save the WIP limit")
      throw error
    }
  }
  const sprintTotal = Object.values(issueCountObj || {}).reduce((sum, count) => sum + (Number.isFinite(count) && count > 0 ? count : 0), 0)
  const sprintDone = Math.max(0, Number(issueCountObj?.Done) || 0)
  const sprintProgress = sprintTotal ? Math.min(100, Math.round((sprintDone / sprintTotal) * 100)) : 0

  /* Nothing is running, so there is no board to look at. Send the team straight
     to the backlog — that is where the next sprint gets planned and where new
     items are written — instead of parking them on a dead-end card. `replace`
     keeps Back going wherever they came from rather than bouncing them here
     again. */
  const isRedirectingToBacklog = !isBootingBoard && !hasActiveSprint && Boolean(projectSlug)

  useEffect(() => {
    if (!isRedirectingToBacklog) return
    navigate(`/projects/${projectSlug}/backlog`, { replace: true })
  }, [isRedirectingToBacklog, projectSlug, navigate])

  return (
    <Box className={`active-sprint-main-cls active-sprint-board ${isKanban ? "is-kanban-board" : ""}`}>
      <SnackbarComponent 
        message={snackbarMessage}
        isOpen={snackbarOpen}
        onClose={handleSnackbarClose}
      />
      {/* ----------------------------------------------------------------
          Sprint header: breadcrumb + actions, sprint identity, and the
          search / people / filter toolbar in one card.
          ---------------------------------------------------------------- */}
      {isBootingBoard || isRedirectingToBacklog ? <SprintBootLoader /> : (<>
      <section className="sprint-hero">
        <div className="sprint-hero__top">
          <div className="sprint-hero__crumbs">
            {!Skeleton ? <BreadcrumbsComponent /> : <NormalSkeleton width={200} extraStyles="my-1" />}
          </div>

          <div className="sprint-actions">
            <Tooltip title={ShowCopied ? "URL Copied" : "Copy link to this board"}>
              <button type="button" className="sprint-icon-btn d-none d-md-inline-flex" onClick={() => handleCopyUrl()} aria-label="Copy board link">
                <LinkRoundedIcon />
              </button>
            </Tooltip>
            {Skeleton ? <NormalSkeleton /> : hasActiveSprint ? (
              duration >= 0 ?
                <Tooltip title={isKanban
                  ? "Release date: " + moment(activeSprint?.releaseDate || activeSprint?.endDate).format("DD MMM YYYY")
                  : "Sprint duration: " + moment(activeSprint?.startDate).format("DD MMM YYYY") + " - " + moment(activeSprint?.endDate).format("DD MMM YYYY")}>
                  <span className={`sprint-days-chip ${remaingWorkingDays <= 2 ? "is-urgent" : ""}`}>
                    <AccessTimeRoundedIcon />
                    <strong>{remaingWorkingDays}</strong>
                    {remaingWorkingDays === 1 ? "day" : "days"} {isKanban ? "to release" : "remaining"}
                  </span>
                </Tooltip>
                : null
            ) : null}
            {Skeleton ? <NormalSkeleton variant='rectangular' height={30} /> : hasActiveSprint ? (
              <Button
                onClick={() => {
                  handleCompletSprint()
                }}
                className="sprint-complete-btn"
                startIcon={<FlagRoundedIcon />}
                disableRipple
              >
                {isKanban ? "Complete release" : "Complete Sprint"}
              </Button>
            ) : null}
            <button type="button" className="sprint-icon-btn hover-disable d-none d-md-inline-flex" aria-label="More actions" aria-disabled="true">
              <MoreHorizRoundedIcon />
            </button>
          </div>
        </div>

        <div className="sprint-hero__main">
          {!Skeleton ? (
            <div className="sprint-hero__identity">
              <span className="sprint-hero__tile" aria-hidden="true">
                {isKanban ? <ViewKanbanRoundedIcon /> : <DirectionsRunRoundedIcon />}
              </span>
              <div className="sprint-hero__heading">
                <Typography component="h1" className="sprint-board-title">
                  {activeSprint?.name ? activeSprint?.name : "Sprint Board"}
                  {isKanban ? <span className="sprint-kanban-tag">Kanban</span> : null}
                </Typography>
                {hasActiveSprint ? (
                  <div className="sprint-hero__meta">
                    {isKanban && (activeSprint?.releaseDate || activeSprint?.endDate) ? (
                      <span className="sprint-meta-chip">
                        <CalendarMonthRoundedIcon />
                        Release {moment(activeSprint?.releaseDate || activeSprint?.endDate).format("DD MMM YYYY")}
                      </span>
                    ) : activeSprint?.startDate && activeSprint?.endDate ? (
                      <span className="sprint-meta-chip">
                        <CalendarMonthRoundedIcon />
                        {moment(activeSprint?.startDate).format("DD MMM")} – {moment(activeSprint?.endDate).format("DD MMM YYYY")}
                      </span>
                    ) : null}
                    {sprintTotal > 0 ? (
                      <Tooltip title={`${sprintProgress}% of this sprint's issues are done`}>
                        <span className="sprint-progress">
                          <span className="sprint-progress__track">
                            <span className="sprint-progress__fill" style={{ width: `${sprintProgress}%` }} />
                          </span>
                          <span className="sprint-progress__label">
                            <TaskAltRoundedIcon />
                            {sprintDone}/{sprintTotal} done
                          </span>
                        </span>
                      </Tooltip>
                    ) : null}
                  </div>
                ) : null}
              </div>
            </div>
          ) : <NormalSkeleton width={200} extraStyles="my-1" />}

          {(!Skeleton && hasActiveSprint && duration <= 0) &&
            <Alert severity="warning" icon={<WarningAmberRoundedIcon fontSize="inherit" />} className="sprint-duration-alert-cls">
              <div className="timeline-update-sprint">
                <span>{isKanban ? "Release: " : "End of sprint: "}</span>
                {isKanban
                  ? (duration === 0 ? "Release is due today!" : duration < 0 ? "Release date has passed" : '')
                  : (duration === 0 ? "Sprint ends in 0 days!" : duration < 0 ? "Sprint Duration Completed" : '')}
                <NavLink className='navlink'
                  onClick={() => {
                    setOpenModal(true);
                    setSprinId(activeSprint?._id);
                    setIsSprintEditable(true);
                  }}
                >
                  {isKanban ? "Update release" : "Update Sprint"}
                </NavLink>
              </div>
            </Alert>
          }
        </div>

        {!Skeleton && hasActiveSprint ? (
          <DeliveryTracker
            sprintId={activeSprint?._id}
            isKanban={isKanban}
            refreshKey={`${JSON.stringify(issueCountObj || {})}|${activeSprint?.endDate || ""}|${JSON.stringify(wipLimits)}`}
          />
        ) : null}

        <div className="sprint-toolbar">
          <BacklogHeader
            className="sprint-filters"
            menuClassName="sprint-filter-menu"
            popoverClassName="sprint-people-pop"
            setOpenAddPeopleModel={setOpenAddPeopleModel}
            searchTerm={searchTerm}
            handleSearch={handleSearch}
            handleStatuUpdate={handleStatuUpdate}
            handlePriorityUpdate={handlePriorityUpdate}
            selectedTaskType={selectedTaskType}
            selectPriorityType={selectPriorityType}
            EpicsData={activeSprintEpicsData}
            // EpicsData={selectedProjectEpicsData}
            handleEpicData={handleEpicData}
            selectedEpic={selectedEpic}
          />
          <Box className="sprint-toolbar__group d-none d-lg-block">
            {Skeleton ? <NormalSkeleton variant='rectangular' height={30} /> : (
              <Box className="sprint-groupby-tabs" data-active={groupBy === "assignee" ? "assignee" : "status"} role="tablist" aria-label="Group board by">
                <span className="sprint-groupby-thumb" aria-hidden="true" />
                <button
                  type="button"
                  role="tab"
                  aria-selected={groupBy === "none"}
                  onClick={() => setGroupBy("none")}
                  className={`sprint-groupby-tab ${groupBy === "none" ? "is-active" : ""}`}
                >
                  <ViewWeekRoundedIcon />
                  {isKanban ? "Flow" : "Status"}
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={groupBy === "assignee"}
                  onClick={() => setGroupBy("assignee")}
                  className={`sprint-groupby-tab ${groupBy === "assignee" ? "is-active" : ""}`}
                >
                  <GroupsRoundedIcon />
                  Assignee
                </button>
              </Box>
            )}
          </Box>
        </div>
      </section>
      <div className="sprint-board-scroll">
        <div className={`${groupBy === "assignee" ? "py-3" : "pb-3"}`}>
          {(activeSprint && (Object.keys(activeSprint)?.length > 0 || Skeleton)) ?
            (
              groupBy === "assignee" ?
                <ActiveSprintAssigneesLayout
                  issueType={issueType}
                  priority={priority}
                  setPriority={setPriority}
                  searchTerm={searchTerm}
                  setIssueType={setIssueType}
                  activeSprintId={activeSprint?._id}
                  issueStatusList={issueStatusList}
                  currentTaskIndex={currentTaskIndex}
                  isEditing={isEditing}
                  handleCreateIssueClick={handleCreateIssueClick}
                  handleChangeIssueTitle={handleChangeIssueTitle}
                  handleClickAway={handleClickAway}
                  handleTextareaSubmit={handleTextareaSubmit}
                  onChangeModalStatus={onChangeModalStatus}
                  handleColumnDrop={handleColumnDrop}
                  draggedTodoItem={draggedTodoItem}
                  selectedIssueType={selectedTaskType}
                  selectPriorityType={selectPriorityType}
                  newTaskTitle={newTaskTitle}
                  handleSaveIssue={handleSaveIssue}
                  handleCancelIssue={handleCancelIssue}
                  handleEditClick={handleEditClick}
                  handleDeleteTaskStatus={handleDeleteTaskStatus}
                  editingTaskIndex={editingTaskIndex}
                  setNewTaskTitle={setNewTaskTitle}
                  showInput={showInput}
                  handleAddTaskItem={handleAddTaskItem}
                  inputValue={inputValue}
                  setInputValue={setInputValue}
                  handleCancelClick={handleCancelClick}
                  inputRef={inputRef}
                  handleSaveClick={handleSaveClick}
                  // Pass assignee update functionality to assignee layout
                  assigneeUpdating={assigneeUpdating}
                  handleAssigneeUpdate={handleAssigneeUpdate}
                  handlePopOverClick={handlePopOverClick}
                  handlePopOverClose={handlePopOverClose}
                  anchorEl={anchorEl}
                  contributors={contributors}
                />
                : isKanban && !Skeleton ? (
                  <KanbanBoard
                    columns={issueStatusList}
                    issues={filteredData}
                    counts={issueCountObj}
                    wipLimits={wipLimits}
                    canEdit={userAccess}
                    dragRef={draggedTodoItem}
                    activeZone={activeZone}
                    getZoneProps={getZoneProps}
                    clearZone={clearZone}
                    onDropToColumn={(title) => handleColumnDrop(title, "issue")}
                    onOpen={onChangeModalStatus}
                    onCreate={handleKanbanCreate}
                    onWipSave={handleWipSave}
                    contributors={contributors}
                    assigneeUpdating={assigneeUpdating}
                    onAssigneeUpdate={handleAssigneeUpdate}
                  />
                ) : (

                  <Box sx={{ flexGrow: 1 }} className="px-3 mt-3">
                    <Grid container spacing={1} className="sprint-grid-layout-container-cls pb-3" sx={{ flexWrap: 'nowrap', overflowX: 'auto' }} >
                      {issueStatusList?.map((eachTask, index) => {
                        return (
                          <Grid item xs={12} sm={6} md={4} lg={2} key={`sprint-grid--${eachTask.title}`} sx={{ display: 'flex', flexDirection: 'column', flexShrink: 0 }}>

                            <Box sx={{
                              alignSelf: 'stretch',
                              height: '100%'
                            }}>
                              <EachTask
                                className={`shadow-none p-1 task-card-hover-cls status-column-body ${dropStateClass(eachTask?.title)} ${isKanban && isOverWip(issueCountObj?.[eachTask?.title] || 0, wipLimits[eachTask?._id]) ? "is-over-wip" : ""}`}
                                {...getZoneProps(`status-${eachTask?.title}`)}
                                onDrop={(e) => {
                                  clearZone();
                                  handleColumnDrop(
                                    eachTask.title, "issue"
                                  );
                                }}
                              >
                              {/* the lane's name, pinned to the top of its own lane:
                                  bold label, count in a pill, no card and no icon */}
                              {!Skeleton ? (
                                <div className="status-column-head">
                                  {userAccess && isEditing && editingTaskIndex === index ? (
                                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: '2px' }}>
                                      <TextField
                                        value={newTaskTitle}
                                        onChange={(e) => setNewTaskTitle(e.target.value)}
                                        autoFocus
                                        size="small"
                                        variant="outlined"
                                        sx={{ flexGrow: 1 }}
                                      />
                                      <IconButton color="primary" size="small" onClick={() => handleSaveIssue(index, eachTask._id)}>
                                        <CheckIcon fontSize="small" />
                                      </IconButton>
                                      <IconButton color="secondary" size="small" onClick={handleCancelIssue}>
                                        <CloseIcon fontSize="small" />
                                      </IconButton>
                                    </Box>
                                  ) : (
                                    <>
                                      <span className="each-task-status-title-cls">
                                        {eachTask?.title}
                                      </span>
                                      {isKanban ? (
                                        <WipLimitControl
                                          title={eachTask?.title}
                                          count={issueCountObj?.[eachTask?.title] || 0}
                                          limit={wipLimits[eachTask?._id] || null}
                                          canEdit={userAccess}
                                          onSave={(limit) => handleWipSave(eachTask?._id, limit)}
                                        />
                                      ) : (
                                        <span className="each-tasks-cls">
                                          {issueCountObj?.[eachTask?.title] || 0}
                                        </span>
                                      )}
                                      {userAccess && !isEditing && issueCountObj?.[eachTask?.title] == 0 && (
                                        <span className="status-column-actions">
                                          <EditIcon
                                            className="edit-icon task-status-icon"
                                            onClick={() => handleEditClick(index, eachTask?.title)}
                                          />
                                          <DeleteIcon
                                            className="delete-icon task-status-icon"
                                            onClick={() => handleDeleteTaskStatus(eachTask?._id)}
                                          />
                                        </span>
                                      )}
                                    </>
                                  )}
                                </div>
                              ) : (
                                <IssueStatusCardSkeleton isStatus={true} />
                              )}
                                {!Skeleton ? <>
                                  {filteredData.map((eachProjectTask) =>
                                    eachTask?.title?.toLowerCase() ===
                                      eachProjectTask?.status?.toLowerCase() ? (
                                      <Box
                                        key={eachProjectTask._id}
                                        className="d-flex flex-column justify-content-between task-item sprint-issue-card mb-1"
                                        draggable
                                        onDragStart={(e) =>
                                          (draggedTodoItem.current = { id: eachProjectTask?._id, status: eachProjectTask?.status, draggedItemType: 'issue' })
                                        }
                                        onDragEnd={clearZone}
                                        onDragOver={(e) => e.preventDefault()}
                                      >
                                        <div className="d-flex align-items-center" style={{ flexGrow: 1 }}>
                                          <Tooltip title={eachProjectTask.issueType || "Story"}>
                                            {getIssueTypeIcon(eachProjectTask?.issueType)}
                                          </Tooltip>
                                          <Typography className="issue-key-cls" sx={{ marginLeft: "4px" }}>
                                            {eachProjectTask?.name}
                                          </Typography>
                                        </div>
                                        <Typography
                                          className="task-title"
                                          style={{ maxWidth: "max-content" }}
                                          onClick={() =>
                                            onChangeModalStatus(eachProjectTask)
                                          }
                                        >
                                          {eachProjectTask?.summary}
                                        </Typography>
                                        <div
                                          className="d-flex justify-content-between align-items-center mt-2"
                                          style={{ width: "100%" }}
                                        >
                                          <div className="d-flex align-items-center" style={{ margin: "0px", flexGrow: 1 }}>
                                            <Tooltip title={"Story point"}>
                                              <span className="badge rounded-pill">
                                                <Button className="StoryPoint_badge">
                                                  {eachProjectTask?.storyPointEstimate}
                                                </Button>
                                              </span>
                                            </Tooltip>
                                          </div>
                                          <div style={{ flex: 2, justifyContent: 'center' }}>
                                            <Tooltip title={eachProjectTask.priority || "Urgent"}>
                                              {getPriorityIcon(eachProjectTask.priority)}
                                            </Tooltip>
                                          </div>
                                          <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                            <Button
                                              size="small"
                                              className="assingeeBtnDropdown_main"
                                              aria-describedby={eachProjectTask?._id}
                                              onClick={(event) => handlePopOverClick(event, eachProjectTask?._id)}
                                              disabled={assigneeUpdating === eachProjectTask?._id}
                                              sx={{
                                                position: 'relative',
                                                opacity: assigneeUpdating === eachProjectTask?._id ? 0.7 : 1
                                              }}
                                            >
                                              {assigneeUpdating === eachProjectTask?._id && (
                                                <Box
                                                  sx={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    zIndex: 10
                                                  }}
                                                >
                                                  <EnhancedLoader size="small" text="" />
                                                </Box>
                                              )}
                                              <Box sx={{ opacity: assigneeUpdating === eachProjectTask?._id ? 0 : 1 }}>
                                                <BackgroundLetterAvatarsLogo
                                                  LogoTitle={eachProjectTask?.assignee ? eachProjectTask?.assignee[0]?.employeeName || eachProjectTask?.assignee[0]?.employeeEmail : ""}
                                                  RequiredFontSize="10px  !important"
                                                  extraIdName="assignee-layout-avatar-cls"
                                                />
                                              </Box>
                                            </Button>

                                            <Popover
                                              id={eachProjectTask?._id}
                                              open={anchorEl?.id === eachProjectTask?._id}
                                              anchorEl={anchorEl?.element}
                                              onClose={assigneeUpdating === eachProjectTask?._id ? undefined : handlePopOverClose}
                                              disableEscapeKeyDown={assigneeUpdating === eachProjectTask?._id}
                                              anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "left",
                                              }}
                                              PaperProps={{
                                                sx: {
                                                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
                                                  borderRadius: '15px',
                                                  padding: 1,
                                                  width: 280,
                                                  maxHeight: '320px',
                                                  overflow: 'hidden',
                                                  border: '1px solid rgba(0, 0, 0, 0.05)',
                                                },
                                              }}
                                            >
                                              <Box sx={{ 
                                                position: 'relative',
                                                minHeight: '60px',
                                              }}>
                                                {assigneeUpdating === eachProjectTask?._id && (
                                                  <Box
                                                    sx={{
                                                      position: 'absolute',
                                                      top: 0,
                                                      left: 0,
                                                      right: 0,
                                                      bottom: 0,
                                                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                                      display: 'flex',
                                                      flexDirection: 'column',
                                                      alignItems: 'center',
                                                      justifyContent: 'center',
                                                      zIndex: 1000,
                                                      borderRadius: '8px',
                                                      backdropFilter: 'blur(2px)'
                                                    }}
                                                  >
                                                    <EnhancedLoader 
                                                      size="medium" 
                                                      text="Updating assignee..." 
                                                      variant="dots"
                                                    />
                                                  </Box>
                                                )}
                                                <Box sx={{
                                                  opacity: assigneeUpdating === eachProjectTask?._id ? 0.3 : 1,
                                                  pointerEvents: assigneeUpdating === eachProjectTask?._id ? 'none' : 'auto',
                                                  transition: 'opacity 0.2s ease'
                                                }}>
                                                  <SearchableDropdown
                                                    workFlowModalTaskData={eachProjectTask}
                                                    members={contributors}
                                                    handleAssigneeUpdate={handleAssigneeUpdate}
                                                  />
                                                </Box>
                                              </Box>
                                            </Popover>
                                          </div>
                                        </div>
                                      </Box>
                                    ) : null
                                  )}
                                  {index === currentTaskIndex && isEditing ? (
                                    <ClickAwayListener onClickAway={handleClickAway}>
                                      {/* the composer is a card of the lane's own width — type and
                                          priority share one footer row with Create so nothing can
                                          push it past the lane edge */}
                                      <Box
                                        component="form"
                                        className="sprint-inline-composer"
                                        onSubmit={(event) =>
                                          handleTextareaSubmit(event, eachTask.title)
                                        }
                                      >
                                        <Textarea
                                          variant="plain"
                                          placeholder="What needs to be done?"
                                          className="sprint-grid-layout-create-issue-input"
                                          minRows={2}
                                          maxRows={6}
                                          autoFocus
                                          onChange={handleChangeIssueTitle}
                                        />
                                        <div className="sprint-inline-composer__footer">
                                          <div className="sprint-inline-composer__meta">
                                            <IssueTypeMenuList
                                              labelText="Issue type"
                                              ItemsList={taskTypesList}
                                              setSelectedValue={setIssueType}
                                              selectedValue={issueType}
                                              isActiveSprintPage={true}
                                            />
                                            <IssueTypeMenuList
                                              labelText="Urgent"
                                              ItemsList={taskPriorityList}
                                              setSelectedValue={setPriority}
                                              selectedValue={priority}
                                              isActiveSprintPage={true}
                                            />
                                          </div>
                                          <Button
                                            type="submit"
                                            size="small"
                                            variant="contained"
                                            color="success"
                                            className="sprint-grid-layout-create-issue-btn"
                                          >
                                            Create
                                          </Button>
                                        </div>
                                      </Box>
                                    </ClickAwayListener>
                                  ) : (
                                    <button
                                      onClick={() => handleCreateIssueClick(index)}
                                      className={` active-sprints-create-issue-btn-cls py-2`}
                                    >
                                      <FiPlus className="me-1" />
                                      Create Issue
                                    </button>
                                  )}</> : <IssueStatusCardSkeleton isStatus={false} />
                                }
                              </EachTask>
                            </Box>

                          </Grid>)
                      })
                      }
                      {userAccess && <div className="d-flex flex-column  justify-content-start">
                        {!showInput ? (
                          issueStatusList?.length < 8 && (
                            <Box
                              sx={{
                                minWidth: 100,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop: '10px'
                              }}
                            >
                              <IconButton color="primary" className="add-status-btn" onClick={handleAddTaskItem}>
                                <FiPlus />
                              </IconButton>
                            </Box>
                          )
                        ) : (
                          <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 100, marginLeft: '8px', marginTop: '8px' }} >
                            <TextField
                              variant="outlined"
                              size="small"
                              className="add-status-input"
                              value={inputValue}
                              onChange={(e) => setInputValue(e.target.value)}
                              fullWidth
                              onFocus={() => inputRef.current?.focus()}
                              sx={{ width: '150px' }}
                            />
                            <Box sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'flex-end',
                              mt: 0
                            }}>
                              <IconButton color="primary" onClick={handleSaveClick}>
                                <CheckIcon />
                              </IconButton>
                              <IconButton color="secondary" onClick={handleCancelClick}>
                                <CloseIcon />
                              </IconButton>
                            </Box>
                          </Box>
                        )}
                      </div>}

                    </Grid>
                  </Box>
                )
            )

            : (
              <div className="empty-spint-card-cls p-4 mx-3 my-2">
                <div className="text-center py-3">
                  <img
                    src={ScrumCycleImage}
                    alt="ScrumCycleImage"
                    width="200px"
                    height="160px"
                  />
                  <h6 className="empty-spint-card-title">
                    Get Started In the backlog
                  </h6>
                  <p className="empty-spint-card-para">
                    Plan and start a sprint to see issues here.
                  </p>
                  <button
                    className="empty-spint-card-btn px-4 py-2"
                    onClick={handileNavigation}
                  >
                    Go to Backlog
                  </button>
                </div>
              </div>
            )}
        </div>
      </div >
      </>)}
      {modalOpen && (<TaskWorkFlowModalPage open={modalOpen} activeSprintName={(activeSprint?.name)} handleChangeModalOpen={() => setModalOpen(!modalOpen)} selectedissueId={workFlowModalData?._id} projectDetails={projectDetails} issueStatusList={issueStatusList} getUpdatedBurnDownInfo={getUpdatedBurnDownInfo} issueName={selectedIssueName} />)}
      {
        openAddPeopleModel && (
          <AddPeopleToProject
            open={openAddPeopleModel}
            ProjectName={ProjectName}
            setOpenAddPeopleModel={setOpenAddPeopleModel}
          />
        )
      }
      <CompletConfirmationModal
        open={openDeleteDialog}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleConfirm}
        title="Complet Sprint ?"
        description="Are you sure you want to proceed?"
        btnText="Yes"
        isCompleteConfirm={true}
        buttonStyles={buttonStyles}
        activeSprint={activeSprint}
        AllsprintDetails={projectIssuesData}
        setOpenDeleteDialog={setOpenDeleteDialog}
      />
      {openModal ? (
        <SprintStartModal
          setOpenModal={setOpenModal}
          handleStartSprint={() => handleStartSprint(sprintId)}
          sprintData={activeSprint}
          isSprintEditable={isSprintEditable}
          setIsSprintEditable={setIsSprintEditable}
        />

      ) : null
      }
      {openTaskStatusDialog ? (
        <DeleteTaskStatus
          open={openTaskStatusDialog}
          handleClose={handleCloseModal}
          handleDelete={handleDeleteConfirm} />) : null
      }
    </Box >
  )
}

export default ActiveSprintPage